import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import styles from './folders_toast.module.scss';

export const FoldersToastDecisionAdded: FC<{
  title: string;
  href: string;
}> = ({ href, title }) => (
  <p>
    <FormattedMessage
      id="folders/toast/FoldersToast.tsx/1"
      values={{
        link: (
          <Hyperlink href={href} className={styles.link}>
            {title}
          </Hyperlink>
        ),
      }}
    />
  </p>
);

export const FoldersToastDecisionRemoved: FC<{
  folderKey: string;
  title: string;
}> = ({ folderKey, title }) => (
  <p>
    <FormattedMessage
      id="folders/toast/FoldersToast.tsx/2"
      values={{
        link: (
          <Hyperlink
            href={`/dossiers/${folderKey}?source=folder-toaster-delete`}
            className={styles.link}
          >
            {title}
          </Hyperlink>
        ),
      }}
    />
  </p>
);

export const FoldersToastFolderCreated: FC<{
  href: string;
  title: string;
}> = ({ href, title }) => (
  <p>
    <FormattedMessage
      id="folders/toast/FoldersToast.tsx/3"
      values={{
        link: (
          <Hyperlink href={href} className={styles.link}>
            {title}
          </Hyperlink>
        ),
      }}
    />
  </p>
);

export const FoldersToastFolderAlreadyAdded: FC<{
  href: string;
  title: string;
}> = ({ href, title }) => (
  <p>
    <FormattedMessage
      id="folders/toast/FoldersToast.tsx/5"
      values={{
        link: (
          <Hyperlink href={href} className={styles.link}>
            {title}
          </Hyperlink>
        ),
      }}
    />
  </p>
);
